//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import ReportMaterialsAvailable from './ReportMaterialsAvailable.vue'
import ReportMaterialsConsuming from './ReportMaterialsConsuming.vue'
import ReportContentSection from '../ReportContent/ReportContentSection.vue'
import { autoDebitOfferMixin } from './ReportMaterialsAutoDebitOffer.js'

export default {
  components: {
    ReportMaterialsConsuming: ReportMaterialsConsuming,
    ReportMaterialsAvailable: ReportMaterialsAvailable,
    ReportContentSection
  },
  mixins: [autoDebitOfferMixin],
  props: {
    reportId: {
      type: Number,
      default: null
    },
    reportName: {
      type: String,
      default: null
    },
    reports: {
      type: Array,
      default () {
        return null
      }
    },
    checking: {
      type: Boolean,
      default: false
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    request: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data: function () {
    return {
      materialesAvailable: [],
      standardSpecificationsByReport: {},
      demountings: [],
      mountings: [],
      debits: [],
      consumptions: [],

      materialsCollapse: [],
      materialsgroupCollapse: {},
      materialsAvailableOpen: false,
      materialsAvailableLoaded: false,
      standardSpecificationsLoaded: false,
      contractorAutoDebitOffered: false
    }
  },
  computed: {
    reportActionsAccess: function () {
      return this.report.actionsAccess ? this.report.actionsAccess : {}
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  created: function () {
    this.getMaterialsAvailable()
    this.getStandardSpecifications()
    if (this.report.reports && this.report.reports.length) {
      this.report.reports.forEach((report) => {
        this.$set(this.materialsgroupCollapse, report.id, false)
      })
    }
  },
  methods: {
    onCollapse: function (index, reportId) {
      if (this.materialsgroupCollapse[reportId] !== undefined) {
        this.materialsgroupCollapse[reportId] = true
      }
      if (this.materialsCollapse.indexOf(index + 1) === -1) {
        this.materialsCollapse.push(index + 1)
      }
      this.$emit('default-opened-collapse-materials')
    },
    onChangeMaterialesAvailable: function (materialesAvailable) {
      this.materialesAvailable = [...materialesAvailable]
      this.syncMaterialesAvailableToReport(this.materialesAvailable)
    },
    syncMaterialesAvailableToReport: function (materialesAvailable) {
      if (!this.report) {
        return
      }
      this.$set(this.report, '_materialesAvailable', materialesAvailable)
    },
    syncStandardSpecificationsToReport: function (map) {
      if (!this.report) {
        return
      }
      this.$set(this.report, '_standardSpecificationsByReport', map)
      if (this.report.reports && this.report.reports.length) {
        this.report.reports.forEach(child => {
          const items = map[child.id] || map[String(child.id)] || []
          this.$set(child, '_standardSpecification', items)
        })
      } else if (this.reportId != null) {
        const items = map[this.reportId] || map[String(this.reportId)] || []
        this.$set(this.report, '_standardSpecification', items)
      }
    },
    getMaterialsAvailable: function () {
      axiosGet({
        url: '/service/delta/report/' + this.reportId + '/stocktools',
        onSuccess: (response) => {
          this.materialesAvailable = response.data.result || []
          this.syncMaterialesAvailableToReport(this.materialesAvailable)
          this.materialsAvailableLoaded = true
          this.tryOfferContractorAutoDebit()
        },
        onFailure: 'Ошибка получения доступных материалов',
        msgTarget: this
      })
    },
    getStandardSpecifications: function () {
      const reportIds = this.reports && this.reports.length
        ? this.reports.map(r => r.id)
        : (this.reportId != null ? [this.reportId] : [])
      if (!reportIds.length) {
        this.standardSpecificationsByReport = {}
        this.syncStandardSpecificationsToReport({})
        this.standardSpecificationsLoaded = true
        this.tryOfferContractorAutoDebit()
        return
      }
      axiosGet({
        url: '/service/delta/report/standardSpecification?reportIds=' + reportIds.join(','),
        onSuccess: (response) => {
          const map = {}
          const result = response.data.result || []
          result.forEach(entry => {
            map[entry.reportId] = entry.items || []
          })
          this.standardSpecificationsByReport = map
          this.syncStandardSpecificationsToReport(map)
          this.standardSpecificationsLoaded = true
          this.tryOfferContractorAutoDebit()
        },
        onFailure: 'Ошибка получения типовой спецификации',
        msgTarget: this
      })
    },
    tryOfferContractorAutoDebit: async function () {
      if (this.contractorAutoDebitOffered) {
        return
      }
      if (!this.materialsAvailableLoaded || !this.standardSpecificationsLoaded) {
        return
      }
      this.contractorAutoDebitOffered = true
      await this.offerContractorAutoDebitOnReportOpen()
    }
  }
}

